import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import FinishedBanner from './FinishedBanner.jsx';

const FinishedPrizeBanner = () => {
  const { t } = useTranslation('posts');

  return (
    <FinishedBanner
      header={t('prizeBanner.pickWinners')}
      description={t('prizeBanner.pickWinnerDescription')}
      btnIcon={<AwardIcon />}
      btnText={t('prizeBanner.pickWinners')}
    />
  );
};

export default FinishedPrizeBanner;

const AwardIcon = styled.i.attrs({
  className: 'fa-thin fa-award-simple fa-xl',
})`
  margin-right: 5px;
`;
